module.exports = __webpack_public_path__ + "img/5.1553ab6d.png";